import { render, staticRenderFns } from "./AdminWorkshopStockOrdersEditScreen.vue?vue&type=template&id=84ed5aee&scoped=true&"
import script from "./AdminWorkshopStockOrdersEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminWorkshopStockOrdersEditScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkshopStockOrdersEditScreen.vue?vue&type=style&index=0&id=84ed5aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ed5aee",
  null
  
)

export default component.exports